export function dataUrlToFile(dataUrl: string, filename: string): File {
    const parts = dataUrl.split(',');
    if (parts.length < 2) {
        throw new Error('Invalid data URL');
    }
    const mimeMatch = parts[0].match(/:(.*?);/);
    const mime = mimeMatch?.[1] ?? 'image/png';
    const bstr = atob(parts[1]);
    const u8 = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; i++) {
        u8[i] = bstr.charCodeAt(i);
    }
    const blob = new Blob([u8], {type: mime});
    return new File([blob], filename, {type: mime});
}

export function downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
    URL.revokeObjectURL(url);
}
